import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ui-api-error',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './api-error.component.html',
  styleUrl: './api-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiErrorComponent {
  readonly image = input('assets/images/no-results.svg');
  readonly headline = input('Fehler beim Laden');
  readonly message = input('Es ist ein Fehler aufgetreten.');
  readonly showBack = input(false);
  readonly showRetry = input(false);
  readonly retry = output();
  readonly back = output();
}
